import { useEffect } from 'react';
import { appContext } from '@provider/app-context';
import { useBacklinkUrl } from '../state/hook.backlink-url.js';
import { header, heading, backlinkWrapper, backlinkPill, backlink } from './header.context.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function ComponentHeader(props) {
  const backlink$1 = useBacklinkUrl(props.component.entryKey);
  useEffect(() => {
    appContext.getPageAuthors().catch(() => {
      /** no-op */
    });
  }, []);
  return /*#__PURE__*/jsxs("div", {
    className: header,
    children: [/*#__PURE__*/jsx("h1", {
      className: heading,
      children: props.component.envelope.Title
    }), backlink$1 && /*#__PURE__*/jsxs("div", {
      className: backlinkWrapper,
      children: [/*#__PURE__*/jsx("div", {
        className: backlinkPill,
        children: "Find opgaven her"
      }), /*#__PURE__*/jsx("a", {
        href: backlink$1.href,
        className: backlink,
        children: backlink$1.href
      })]
    })]
  });
}

export { ComponentHeader };
//# sourceMappingURL=header.context.js.map
